// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2fr4R","Footer1":"Footer_Footer1__1tHrz","logo":"Footer_logo__3pNEb"};